<style lang="scss">
@import '~scss/_variables';

.select-fuel {
    display: flex;
    flex-flow: row wrap;
    margin-top: $grid-size * 2;
    margin-bottom: $grid-size * 3;
}

@include media-larger('md') {
    .select-fuel {
        .illustration-radio {
            width: 20%;
        }
    }
}

@include media-smaller('lg') {
    .select-fuel {
        margin-bottom: $grid-size * 2;

        .illustration-radio {
            margin-bottom: $grid-size;
        }
    }
}
</style>

<template>
    <StepBase :index="index" :activeIndex="activeIndex" @set-active="$emit('set-active')">
        <template slot="subtitle">Select <br> A Type Of</template>
        <template slot="title">Fuel</template>

        <div class="step-content step-pad">
            <div class="select-fuel">
                <IllustrationRadio
                    v-for="(data, key) in presets('fuels')"
                    v-model="selectedFuel"
                    :key="key"

                    name="fuel"
                    :id="key"
                    :data="data"
                ></IllustrationRadio>
            </div>
        </div>
    </StepBase>
</template>

<script>
import StepBase from './Base';
import IllustrationRadio from '../entities/IllustrationRadio';

export default {
    extends: StepBase,
    components: {StepBase, IllustrationRadio},
    data () {
        return {
            selectedFuel: null
        };
    },
    computed: {
        canProceed () {
            return !!this.selectedFuel;
        }
    },
    methods: {
        getFormData () {
            return {
                fuel: this.selectedFuel
            };
        }
    },
    watch: {
        selectedFuel () {
            this.proceed();
        }
    }
};
</script>
